
import Vue from 'vue'

export default Vue.extend({
   name: 'DropzoneComponent',
   mounted() {
      const element = this.$refs.dropzoneElement as HTMLInputElement

      const preventDefaultFunction = (evt: Event) => {
         evt.preventDefault()
         return false
      }

      element.addEventListener('dragenter', preventDefaultFunction, false)
      element.addEventListener('dragover', preventDefaultFunction, false)

      element.addEventListener(
         'drop',
         (evt: DragEvent) => {
            evt.preventDefault()

            if (evt.dataTransfer && evt.dataTransfer.files && evt.dataTransfer.files.length) {
               this.$emit('drop', evt.dataTransfer.files)
            }
         },
         false
      )
   },
})
